import CustomProductModal from './CustomProductModal';

export default CustomProductModal;
